import { ArrowUp } from 'lucide-react';

export const SendButton = ({ disabled, hasInput, isTyping }) => (
  <button type="submit" disabled={disabled} className={`w-9 h-9 rounded-full shadow-sm flex items-center justify-center transition-all duration-300 disabled:opacity-50 ${hasInput && !isTyping ? 'bg-[#36a852] text-white hover:bg-[#29807b] hover:scale-105' : 'bg-slate-100 dark:bg-slate-600 text-slate-400 dark:text-slate-300 hover:bg-slate-200 dark:hover:bg-slate-500'}`}>
    <ArrowUp size={18} />
  </button>
);
